import userSignup from './UserSignUp';

const onSignup = (
  values,
  {
    emailExistsError,
    setEmailExistsError,
    setAccountSuccessfullyCreated,
    setErrorMessage,
    onCreationSuccessCallback = null,
    customerAddress,
    setAccountCreationError,
    anonymousId,
  },
) => {
  userSignup(
    emailExistsError,
    setEmailExistsError,
    setAccountSuccessfullyCreated,
    setErrorMessage,
    values.givenName,
    values.familyName,
    values.email,
    values.phoneNumber,
    values.password,
    onCreationSuccessCallback,
    customerAddress,
    setAccountCreationError,
    anonymousId,
  );
};

export default onSignup;
